'use strict';

var GridSaveScenarioButtonDirective = function GridSaveScenarioButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-save-scenario-button.html'),
    controller: 'GridSaveScenarioButtonController',
    link: function link($scope, $element) {
      var mapToggleToGrid = {
        'market-product-group': 'market-product-group-analysis',
        'service': 'service-demand-analysis'
      };
      $scope.$on('keyboard:save', function (ev, originalEv, marketAnalysisToggleMode) {
        if (isDisplayed(marketAnalysisToggleMode)) {
          $scope.onKeyboardChange();
        }
        ev.preventDefault();
        return false;
      });
      function isDisplayed(marketAnalysisToggleMode) {
        var result = true;
        if (marketAnalysisToggleMode) {
          result = mapToggleToGrid[marketAnalysisToggleMode] === $scope.gridPanelScope.gridId;
        }
        return result && $element.css('display') !== 'none' && $element.css('visibility') !== 'hidden';
      }
    }
  };
};
GridSaveScenarioButtonDirective.$inject = [];
module.exports = GridSaveScenarioButtonDirective;